import { isDefined } from './is-defined.util';

export const isOnServer = typeof process !== 'undefined' && isDefined(process);
